import { Col, Row, Layout } from "antd";
import { useTranslation } from "react-i18next";

import BaseHeader from "@/components/Header/BaseHeader";
import { TAB_KEYS } from "@/constants/TabKeys";
import { UserPreferencesNotifications } from "@/modules/user-preferences-notifications";
import { ContextTabs } from "@/ui/context-tabs";

import TabGeneral from "./Tabs/TabGeneral";
import TabPassword from "./Tabs/TabPassword";

const { Content } = Layout;

const Preferences = () => {
  const { t } = useTranslation();
  const tabs = [
    {
      key: TAB_KEYS.PREFERENCES_GENERAL,
      label: t("user:preferences.tabs.general.label"),
      children: <TabGeneral />,
    },
    {
      key: TAB_KEYS.PREFERENCES_PASSWORD,
      label: t("user:preferences.tabs.password.label"),
      children: <TabPassword />,
    },
    {
      key: TAB_KEYS.PREFERENCES_NOTIFICATIONS,
      label: t("user:preferences.tabs.notifications.label"),
      children: <UserPreferencesNotifications />,
    },
  ];
  return (
    <>
      <BaseHeader title={t("navigation:preferences")} />
      <Content>
        <Row justify="left">
          <Col>
            <ContextTabs
              tabPlacement="left"
              key="preference-tabs"
              items={tabs}
            />
          </Col>
        </Row>
      </Content>
    </>
  );
};

export default Preferences;
